export default __webpack_public_path__ + "static/media/PaywallCard_man.6b6f810d.png";